import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function HeroSection() {
  const scrollToContent = () => {
    document.getElementById('emotional-context')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-screen flex items-center justify-center bg-[#0A0A0A] overflow-hidden pt-20 pb-12 px-4" data-id="element-102">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-[#1a1a1a] via-[#0A0A0A] to-[#0A0A0A] opacity-50" data-id="element-103"></div>
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#C5A55A]/30 to-transparent" data-id="element-104"></div>

      <div className="max-w-7xl mx-auto w-full grid grid-cols-1 lg:grid-cols-12 gap-12 items-center relative z-10" data-id="element-105">
        {/* Text Content */}
        <motion.div className="lg:col-span-7 flex flex-col justify-center text-center lg:text-left" initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-106">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif text-[#FAF7F2] leading-tight mb-8" style={{
          fontSize: '28px'
        }} data-id="element-107">
            ¿Y si tu relación no se estuviera apagando…{' '}
            <span className="text-[#C5A55A] italic" data-id="element-108">
              sino pidiendo un nuevo nivel de intimidad?
            </span>
          </h1>

          <motion.div className="flex justify-center lg:justify-start mb-8" initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.2,
          duration: 0.8
        }} data-id="element-109">
            <img src="https://cdn.magicpatterns.com/uploads/dKYFCgZbhFMXzoXJTgVhUs/Logo_18_metodos.jpg" alt="18 Métodos Logo" className="h-36 md:h-48 w-auto object-contain drop-shadow-2xl" data-id="element-110" />
          </motion.div>

          <p className="text-lg md:text-xl text-[#FAF7F2]/80 font-light leading-relaxed mb-8 max-w-2xl mx-auto lg:mx-0" data-id="element-111">
            Una inmersión en vivo para parejas consolidadas que desean
            profundizar su conexión, renovar la intimidad y volver a sentirse
            elegidas —sin terapia eterna y sin superficialidad.
          </p>

          <div className="mb-8 border-l-2 border-[#C5A55A] pl-6 text-left mx-auto lg:mx-0 max-w-xl" data-id="element-112">
            <p className="text-[#D4AF37] font-medium text-sm uppercase tracking-wider mb-2" data-id="element-113">
              La rutina no destruye las relaciones
            </p>
            <p className="text-[#FAF7F2]/90 italic font-serif text-lg" data-id="element-114">
              "Lo que las enfría es dejar de habitarlas con intención."
            </p>
          </div>

          <motion.div whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="flex flex-col items-center lg:items-start" data-id="element-115">
            <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth'
          })} className="bg-[#B91C1C] text-white px-8 py-4 rounded-sm font-medium text-lg shadow-[0_0_20px_rgba(185,28,28,0.4)] hover:shadow-[0_0_30px_rgba(185,28,28,0.6)] transition-all duration-300 flex items-center gap-2 group" data-id="element-116">
              Ver qué incluye y precio
              <ChevronDown className="w-5 h-5 group-hover:translate-y-1 transition-transform" data-id="element-117" />
            </button>
            <p className="mt-4 text-[#C5A55A] text-sm" data-id="element-118">
              Para parejas que se siguen eligiendo, pero no quieren permitir que
              la rutina se adueñe.
            </p>
          </motion.div>
        </motion.div>

        {/* Image Content */}
        <motion.div className="lg:col-span-5 relative" initial={{
        opacity: 0,
        x: 30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.4,
        duration: 0.8
      }} data-id="element-119">
          <div className="relative rounded-lg overflow-hidden border border-[#C5A55A]/30 shadow-[0_0_40px_rgba(197,165,90,0.1)]" data-id="element-120">
            <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-transparent to-transparent opacity-40 z-10" data-id="element-121"></div>
            <img src="https://cdn.magicpatterns.com/uploads/2mkggpq2zWoticVMYNe24j/Foto_2_de_la_DOC_para_pagina_(1).jpg" alt="Beatriz - Inmersión Pareja" className="w-full h-auto object-cover transform hover:scale-105 transition-transform duration-700" data-id="element-122" />
          </div>
          {/* Decorative Frame */}
          <div className="absolute -bottom-4 -right-4 w-full h-full border border-[#C5A55A]/20 -z-10 rounded-lg" data-id="element-123"></div>
        </motion.div>
      </div>
    </section>;
}